import { XMarkIcon } from "@heroicons/react/24/outline";
import { motion, AnimatePresence } from "framer-motion";
import { cn } from "../../lib/utils";

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  title?: string;
  dataTestId?: string;
}

export function Sidebar({ isOpen, onClose, children, title, dataTestId }: SidebarProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 bg-black/20 z-50"
          data-testid={dataTestId}
          initial={{ opacity: 1 }}
          animate={{
            opacity: 1,
            pointerEvents: "auto", // Enable pointer events when visible
          }}
          exit={{
            opacity: 0,
            pointerEvents: "none", // Disable pointer events immediately when closing
          }}
          transition={{
            enter: { duration: 0.3 },
            exit: { duration: 0.2 },
          }}
          onClick={onClose}
        >
          <motion.div
            className="absolute right-0 top-0 h-full min-w-xl bg-dark border-l border-input overflow-y-auto custom-scrollbar"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{
              type: "spring",
              damping: 40,
              stiffness: 600,
              exit: { type: "tween", duration: 0.2 },
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative">
              <div
                className={cn(
                  "flex flex-row justify-between items-center w-full p-4",
                  title ? "justify-between" : "justify-end"
                )}
              >
                {title ? (
                  <h2 className="text-xl font-bold text-white">{title}</h2>
                ) : null}
                <XMarkIcon
                  className="w-4 h-4 cursor-pointer text-white hover:text-secondary"
                  onClick={onClose}
                />
              </div>
            </div>

            <div className="p-4 h-[80%]">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
